const { VITE_APP_STREAMLIT } = import.meta.env

const generateTablePreviewUrl = (encryptedData: string) => {
  return `${VITE_APP_STREAMLIT}/tables?embed=true&embed_options=light_theme&code=${encryptedData}`
}

export { generateTablePreviewUrl }
